import BaseHandler from './BaseHandler';
import InstanceListManager from '../modules/InstanceListManager';
import Collapse from '../modules/Collapse';
import { HANDLERS } from '../constants/globals';


export default class CollapseHandler extends BaseHandler {
  constructor(){
    super();
    this.elements = [];
    this.instanceList = null;
  };

  init = (optionalContainer) => {
    HANDLERS["collapseHandler"] = this;

    this.elements = this.getElementsByDataInit('collapse', optionalContainer);

    if(!this.elements.length > 0){ return };

    this.instanceList = this.createInstanceListByName('collapses');

    let initialTarget = this.getTargetId(document.URL);

    this.elements.forEach((el) => {
      if (this.instanceList.containsElement(el)) { return };
      let collapse = new Collapse(el, optionalContainer);

      if (!el.hasAttribute('id')) el.id = this.createUniqueID('collapse');
      if (initialTarget && initialTarget === el.id) {
        setTimeout(() => collapse.openCollapse(), 0);
      }

      this.instanceList.add(el.id, collapse);
    });
  }

  getTargetId = (string) => {
    var url = string;
    let hasID = url.includes('#');
    return (hasID) ? url.substring(url.lastIndexOf('#') + 1) : false;
  }
}
